export class question_response{
    // question:number;
    response_id:number;
    data:any;
}